import { Component, Inject } from "@angular/core";
import { NX_MODAL_DATA, NxModalRef } from "@aposin/ng-aquila/modal";
import { SharedModule } from "@shared/shared.module";

@Component({
  selector: "app-error-modal",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./error-modal.component.html",
  styleUrl: "./error-modal.component.css",
})
export class ErrorModalComponent {
  txt: any;
  constructor(
    @Inject(NX_MODAL_DATA) data: any,
    private readonly dialogRef: NxModalRef<any>,
  ) {
    this.txt = 'Please try again later.';
    if (data?.e) {
      this.txt = data.e.message;
      if (data.e.status === 0) {
        this.txt = 'Please check your connection and try again.';
      }
      else if (data.e.status === 500) {
        this.txt = 'Internal server error. Please try again later.';
      }
      else if (data.e.status === 503) {
        this.txt = 'Service Unavailable. Please try again later.';
      }
      else if (data.e.status === 504) {
        this.txt = 'Request timeout. Please try again later.';
      }
    }
  }

  onclickOK() {
    this.dialogRef.close("OK");
  }
}
